/** Public product origin for QR / print URLs (not the admin SPA host). */
export const PUBLIC_FRONT_URL = (
  process.env.REACT_APP_PUBLIC_FRONT_URL || "https://www.curbcrew.co.za"
).replace(/\/$/, "");
